import { AuthClientTokens } from "@react-keycloak/core/lib/types";

export interface AuthTokenState extends AuthClientTokens {
  isLogged: boolean;
}

export const AuthTokenStateDefault: AuthTokenState = {
  idToken: undefined,
  refreshToken: undefined,
  token: undefined,
  isLogged: false,
};
